import React from 'react';
import TestChat from './testShell/TestChat';
import riasec from './testShell/configs/riasec';
import RiasecResult from './riasec/RiasecResult';

// RIASEC ("Career interests") in the chat, on the shared test shell instead of Dialogflow.
// A released result opens the interests card and the programs flow (riasec/RiasecResult.js).
const renderResult = (props) => <RiasecResult {...props} />;

const ChatbotRiasec = (props) => <TestChat config={riasec} renderResult={renderResult} {...props} />;

export default ChatbotRiasec;
